import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerValidaFattureModalComponent } from './worker-valida-fatture-modal';

export const WorkerValidaFattureModalModule: string = ng
    .module('worker-valida-fatture-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerValidaFattureModalComponent', WorkerValidaFattureModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-valida-fatture-modal/worker-valida-fatture-modal.module.ts